import { connect } from 'react-redux';

import AppointmentCustomTemplateEmptyPlaceholder from './AppointmentCustomTemplateEmptyPlaceholder';

const mapStateToProps = (state) => ({
  configRequestStatus: state.common.organizationConfig.requestStatus,
  template: state.common.organizationConfig.generalConfig.templateConfigs?.patientEmptyListPlaceholderTemplate,
});

export default connect(mapStateToProps)(AppointmentCustomTemplateEmptyPlaceholder);
